import { StyleSheet } from "@react-pdf/renderer";
import { format } from "date-fns";
import { leadingZerosDateFormat } from "../../../../../common/helpers/formatDateTime";

export const styles = StyleSheet.create({
  document: {
    fontSize: 12,
    fontFamily: "Source Sans Pro",
  },
  section: {
    padding: 10,
    margin: "10px 30px 0px 30px",
  },
  grid: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: 10,
  },
  row: {
    flexDirection: "row",
  },
  heading: {
    fontSize: 14,
    marginBottom: 10,
  },
  paragraph: {
    flexDirection: "row",
    marginBottom: 10,
  },
  bolded: {
    fontWeight: 600,
  },
  padded: {
    paddingRight: 80,
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
  },
  signature: {
    fontFamily: "Helvetica",
  },
});

export const yesNo = (value: boolean) => (value ? "common:yes" : "common:no");

export const formatDate = (dateString: string | undefined) =>
  dateString ? format(dateString, leadingZerosDateFormat) : "";
